import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PolicyLayout } from "./components/site/PolicyLayout";
import { PrivacyPolicy } from "./components/site/PrivacyPolicy";
import "./styles/index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PolicyLayout title="Privacy Policy" effectiveDate="August 17, 2026">
      <PrivacyPolicy />
    </PolicyLayout>
  </StrictMode>,
);
